export const DESC = 'desc';
export const DIMENSIONS = 'dimensions';
export const ACCESSORIES = 'accessories';
export const CUSTOMISE = 'customise';
export const CIRCULAR_ECO = 'circular_eco';
export const CPDIMENSIONS = 'cpdimensions';
